"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.accessibleLabelCheck = void 0;
const accessibleLabelCheck = (ariaLabel, label) => {
    if (ariaLabel === '' || label === '') {
        throw Error('label and ariaLabel may not be empty strings');
    }
};
exports.accessibleLabelCheck = accessibleLabelCheck;
